import type { CSSProperties } from 'react';

/**
 * Inline style that blurs identifying text (client / vessel / project names,
 * aliases, friendly names, service-line numbers, serials) when the global
 * "hide names" setting is on. The text stays in the DOM so the setting can
 * toggle back — this is a screen-share privacy aid, not a security control.
 */
export const blurStyle = (on: boolean): CSSProperties =>
  on ? { filter: 'blur(6px)', userSelect: 'none' } : {};
